var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoostIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "boost-bg",
    fill: "#25254b",
    d: "M30.43 12c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "boost-eye",
    fill: "#ff9b00",
    d: "M24.284 13.55a4.027 4.027 0 01-3.999 3.533 4.027 4.027 0 01-4.031-4.022c0-1.543.871-2.88 2.149-3.555-.49-.446-.992-.925-1.506-1.45-3.301-3.374-7.225-5.258-10.46-6.308C2.776.56 0 .44 0 .44s5.157 2.05 6.293 5.302l.001-.018c.206 4 1.568 9.838 7.515 11.743 9.35 2.995 15.01-2.823 15.01-2.823s-1.7.206-4.535-1.095"
  })));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/boost-icon.svg";
export { SvgBoostIcon as ReactComponent };